import { FC } from 'react';
import { PredefinedAlertProps } from './PredefinedAlert.types';
import { Alert } from '@/_components';

export const PredefinedAlert: FC<PredefinedAlertProps> = () => {
  return (
    <Alert type="info">
      Please explain where/how you provided this document (e.g., Email, Mail,
      In-person).
    </Alert>
  );
};
